import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';
import { ref } from 'vue';
import { useFieldBorder } from '@/common/customisation/composables/useFieldBorder';

/**
 * Composable for ArticleRow component customisation
 * Returns article configuration and styling for a specific article section
 * @param sectionKey - The section key for the specific article (e.g., HOME_SECTION_KEYS.ARTICLE_1)
 */
export const useArticlesCustomisation = (sectionKey: string) => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.HOME,
    sectionKey,
    blockKey: PUI.HOME_BLOCK_KEYS.FEATURED_ARTICLES,
  });

  const articleContent = getField(PUI.COMMON_FIELD_KEYS.ARTICLE_ID);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const { borderColor } = useFieldBorder();

  return {
    isVisible,
    useAutofill: ref(false),
    articleContent,
    textColor,
    borderColor,
  };
};
